import domready from "domready"
import "./style.css"
import HexagonPatch from "./HexagonPatch"


const PHI = (1 + Math.sqrt(5)) / 2;
const TAU = Math.PI * 2;
const DEG2RAD_FACTOR = TAU / 360;


const Mode = {
    TRI: 1,
    QUAD: 2,
    RING: 3
}

const config = {
    width: 0,
    height: 0
};

/**
 * @type CanvasRenderingContext2D
 */
let ctx;
let canvas;

function drawArrow(x0, y0, x1, y1)
{
    const { width, height} = config;

    const cx = width/2;
    const cy = height/2;

    const dy = y1 - y0;
    const dx = x1 - x0;

    if (dx * dx + dy * dy > 2)
    {
        const nx = dy * 0.08
        const ny = -dx * 0.08

        const start = 0.01
        const end = 0.5

        const x2 = x0 + (x1 - x0) * start
        const y2 = y0 + (y1 - y0) * start
        const x3 = x0 + (x1 - x0) * end
        const y3 = y0 + (y1 - y0) * end

        const x4 = x0 + (x1 - x0) * (start + (end - start) * 0.6)
        const y4 = y0 + (y1 - y0) * (start + (end - start) * 0.6)

        ctx.beginPath()
        ctx.moveTo(cx + x2, cy + y2)
        ctx.lineTo(cx + x3, cy + y3)

        ctx.moveTo(cx + x3, cy + y3)
        ctx.lineTo(cx + x4 + nx, cy + y4 + ny)
        ctx.moveTo(cx + x3, cy + y3)
        ctx.lineTo(cx + x4 - nx, cy + y4 - ny)
        ctx.stroke()
    }
}


function renderDebugFace(face, drawNext = false, ids = false)
{
    const { width, height} = config;

    const cx = width/2;
    const cy = height/2;

    const faceCentroid = face.centroid

    ctx.save()
    if (ids)
    {
        const label = String(face.id);
        const tm = ctx.measureText(label);
        ctx.fillStyle = "#ccc"
        ctx.fillText(label, cx + faceCentroid[0] - tm.width/2, cy + faceCentroid[1] + 4)
    }
    else
    {
        ctx.fillStyle = "#0f0"
        ctx.fillRect(cx + faceCentroid[0] - 2, cy + faceCentroid[1] - 2, 4, 4)
    }
    ctx.restore()

    const first = face.halfEdge;
    let curr = first;

    ctx.save()

    ctx.strokeStyle = "#fff"
    ctx.beginPath()

    do
    {
        const next = curr.next;

        const x0 = 0|(cx + curr.vertex.x)
        const y0 = 0|(cy + curr.vertex.y)
        const x1 = 0|(cx + next.vertex.x)
        const y1 = 0|(cy + next.vertex.y)

        if (curr === first)
        {
            ctx.moveTo(x0, y0)
        }
        ctx.lineTo(x1, y1)

        curr = next
    }  while (curr !== first)
    ctx.fill()
    ctx.stroke()
    ctx.restore()

    if (drawNext)
    {
        curr = first
        do
        {
            const next = curr.next

            const x0 = 0 | (cx + curr.vertex.x)
            const y0 = 0 | (cy + curr.vertex.y)
            const x1 = 0 | (cx + next.vertex.x)
            const y1 = 0 | (cy + next.vertex.y)

            const x2 = 0 | ((x0 + x1) / 2 - cx)
            const y2 = 0 | ((y0 + y1) / 2 - cy)

            const {twin} = curr
            if (twin)
            {
                const [x0, y0] = faceCentroid
                ctx.strokeStyle = "#666"
                drawArrow(x2, y2, x0, y0)
            }

            curr = next
        } while (curr !== first)
    }
}

function renderConnections(face, countSmaller, countBigger)
{
    const { width, height} = config;

    const cx = width/2;
    const cy = height/2;

    const first = face.halfEdge;
    let curr = first;

    let numSmaller = 0, numBigger = 0

    do
    {
        const { twin } = curr

        if (twin && twin.face)
        {


            const isSmaller = face.id < twin.face.id

            console.log(face.id, "=>", twin.face.id, ":")

            if (isSmaller)
            {
                countSmaller()
            }
            else
            {
                countBigger()
            }
            if (isSmaller)
            {
                const [x0,y0] = face.centroid
                const [x1,y1] = twin.face.centroid


                ctx.beginPath()
                ctx.moveTo(cx + x0,cy + y0)
                ctx.lineTo(cx + x1,cy + y1)
                ctx.stroke()
            }
        }

        curr = curr.next
    }  while (curr !== first)

}

function hasVertexInScreen(face)
{
    const { width, height} = config;

    const cx = width/2;
    const cy = height/2;

    const first = face.halfEdge;
    let curr = first;

    do
    {
        const x0 = 0|(cx + curr.vertex.x)
        const y0 = 0|(cy + curr.vertex.y)

        if (x0 >= 0 && x0 < width && y0 >= 0 && y0 < height)
        {
            return true
        }

        curr = curr.next
    }  while (curr !== first)

    return false
}

function insertFaces(map, face)
{
    const { width, height} = config;

    const cx = width/2;
    const cy = height/2;

    const first = face.halfEdge;
    let curr = first;

    // ctx.save()
    //
    // ctx.strokeStyle = "#fff"
    // ctx.beginPath()

    do
    {
        const next = curr.next;

        const x0 = 0|(cx + curr.vertex.x)
        const y0 = 0|(cy + curr.vertex.y)
        // const x1 = 0|(cx + next.vertex.x)
        // const y1 = 0|(cy + next.vertex.y)

        const key = x0 + "/" + y0
        let ids = map.get(key)
        if (!ids)
        {
            ids = [ face.id ]
            map.set(key,ids)
        }
        else
        {
            ids.push(face.id)
        }

        // if (curr === first)
        // {
        //     ctx.moveTo(x0, y0)
        // }
        // ctx.lineTo(x1, y1)

        curr = next
    }  while (curr !== first)
    // ctx.stroke()
    // ctx.restore()
}

/**
 * Returns a mode map for the given points map
 * @param map
 * @returns {Map<number, array>}
 */
function classify(map)
{
    const modes = new Map()

    const updateMode = (id, mode,pts) => {
        if (!modes.has(id) || modes.get(id)[0] < mode)
        {
            const m = /(.*)\/(.*)/.exec(pts)

            if (!m)
            {
                throw new Error("FAILED: " + pts)
            }

            modes.set(id, [mode, +m[1], +m[2]])
        }
    }

    for (let [pts, ids] of map)
    {
        if (ids.length >= 5)
        {
            ids.forEach(id => updateMode(id, Mode.RING, pts))
        }
        else if (ids.length === 3)
        {
            ids.forEach(id => updateMode(id, Mode.TRI, pts))
        }
        else if (ids.length === 4)
        {
            ids.forEach(id => updateMode(id, Mode.QUAD, pts))
        }
    }
    return modes
}

domready(
    () => {

        canvas = document.getElementById("screen");
        ctx = canvas.getContext("2d");

        const width = (window.innerWidth) | 0;
        const height = (window.innerHeight) | 0;

        config.width = width;
        config.height = height;

        canvas.width = width;
        canvas.height = height;

        const paint = () => {

            const cx = width >> 1
            const cy = height >> 1

            ctx.fillStyle = "#000";
            ctx.fillRect(0,0, width, height);

            const hexagonSize = 80

            const patch = new HexagonPatch(0, 0, hexagonSize)

            const faces = (
                patch.build()
                    .filter(hasVertexInScreen)
            )

            const pointMap = new Map()
            faces.forEach( face => insertFaces(pointMap, face) )
            const modes = classify(pointMap)

            let smaller = 0
            let bigger = 0

            ctx.lineWidth = 1
            faces.forEach( face => {

                const [mode, x, y] = modes.get(face.id)

                let v
                if (mode === Mode.RING)
                {
                    v = (x * y) & 255
                    ctx.fillStyle = `rgb(${v},${v},${v})`
                }
                else
                {
                    ctx.fillStyle = "#080"
                }
                renderDebugFace(face)
            })
            // ctx.strokeStyle = "#800"
            // ctx.lineWidth = 4
            // faces.forEach( face => renderConnections(face, () => smaller++, () => bigger++))

            console.log({smaller,bigger})
        }



        paint()

        canvas.addEventListener("click", paint, true)
    }
);
